module.exports = "/images/étoiles.png?714c78455b5a8e3903132f9fa57c7717";